module.exports = __webpack_public_path__ + "static/media/dollar.52d12204.svg";